const labelsFullDadesHistoriques = [
    1970, 1971, 1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979,
    1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989,
    1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999,
    2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009,
    2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019,
    2020
];

const getBackgroundGradient = (dades, red, green, blue, border, pointStyle) => {
    return {
        data: dades.map((item) => {
            return { x: item[0], y: item[1] };
        }),
        fill: 'start',
        borderColor: `rgb(${red}, ${green}, ${blue})`,
        backgroundColor: (context) => {
            const bgColor = [
                `rgba(${red}, ${green}, ${blue}, 1)`,
                `rgba(${red}, ${green}, ${blue}, 0.9)`,
                `rgba(${red}, ${green}, ${blue}, 0.8)`,
                `rgba(${red}, ${green}, ${blue}, 0.6)`,
                `rgba(${red}, ${green}, ${blue}, 0.4)`,
                `rgba(${red}, ${green}, ${blue}, 0.2)`,
                'rgba(255, 255, 255, 0.2)'
            ];
            if (!context.chart.chartArea) {
                return;
            }
            const {
                ctx,
                chartArea: { top, bottom }
            } = context.chart;
            const gradientBg = ctx.createLinearGradient(0, top, 0, bottom);
            const colorTranches = 1 / (bgColor.length - 1);
            for (let i = 0; i < bgColor.length; i++) {
                gradientBg.addColorStop(i * colorTranches, bgColor[i]);
            }
            return gradientBg;
        },
        pointStyle: pointStyle,
        borderWidth: border,
        parsing: {
            xAxisKey: 'x',
            yAxisKey: 'y'
        }
    };
}

const getConfigGrafica = (type, dades, alcadaDefinida) => {

    if (type === 'temperaturaMitjana') {
        let maxY = Math.max.apply(
            null,
            dades.map(function (o) {
                return o[1];
            })
        );
        let minY = Math.min.apply(
            null,
            dades.map(function (o) {
                return o[1];
            })
        );
        maxY = maxY + 0.2;
        minY = minY - 0.2;
        return {
            dataSets: [
                getBackgroundGradient(dades, 192, 17, 16, 2, "circle")
            ],
            options: {
                responsive: true,
                maintainAspectRatio: alcadaDefinida ? false : true,
                aspectRatio: 2 / 3,
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: false,
                        text: 'Temperatura mitjana'
                    }
                },
                scales: {
                    x: {
                        labels: dades.map((z) => {
                            return z[0];
                        }),
                        title: {
                            display: true,
                            text: 'Anys'
                        },
                        ticks: {
                            callback: function (value) {
                                const label = this.getLabelForValue(value);
                                return label % 2 === 0 ? label : '';
                            }
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Graus °C'
                        },
                        min: minY,
                        max: maxY,
                        ticks: {
                            stepSize: 0.25
                        }
                    }
                }
            }
        };
    }
    if (type === 'precipitacioAcumulada') {
        let maxY = Math.max.apply(
            null,
            dades.map(function (o) {
                return o[1];
            })
        );
        let minY = Math.min.apply(
            null,
            dades.map(function (o) {
                return o[1];
            })
        );
        maxY = Math.ceil((maxY + 10) / 10) * 10;
        minY = Math.ceil((minY - 10) / 10) * 10;

        return {
            dataSets: [
                {
                    data: dades.map((item) => {
                        return { x: item[0], y: item[1] };
                    }),
                    borderColor: 'rgb(0, 124, 123)',
                    backgroundColor: 'rgb(0, 124, 123)',
                    pointStyle: 'circle',
                    borderWidth: 2,
                    parsing: {
                        xAxisKey: 'x',
                        yAxisKey: 'y'
                    }
                }
            ],
            options: {
                responsive: true,
                maintainAspectRatio: alcadaDefinida ? false : true,
                aspectRatio: 2 / 3,
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: false,
                        text: 'Precipitació acumulade'
                    }
                },
                scales: {
                    x: {
                        labels: dades.map((z) => {
                            return z[0];
                        }),
                        title: {
                            display: true,
                            text: 'Anys'
                        },
                        ticks: {
                            callback: function (value) {
                                const label = this.getLabelForValue(value);
                                return label % 5 === 0 ? label : '';
                            }
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Pluja en mil·límetres (mm)'
                        },
                        min: minY,
                        max: maxY,
                        ticks: {
                            stepSize: 10
                        }
                    }
                }
            }
        };
    }
    if (type === 'diesCalidsINitsTropicals') {
        const maxDies = Math.max.apply(null, dades[0].data);
        const maxNits = Math.max.apply(null, dades[1].data);
        let maxY = maxDies > maxNits ? maxDies : maxNits;
        const minDies = Math.min.apply(null, dades[0].data);
        const minNits = Math.min.apply(null, dades[1].data);
        let minY = minDies < minNits ? minDies : minNits;
        maxY = Math.ceil((maxY + 10) / 10) * 10;
        minY = Math.ceil((minY - 20) / 10) * 10;
        return {
            labels: [
                2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035, 2036, 2037, 2038, 2039, 2040,
                2041, 2042, 2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050
            ],
            dataSets: [
                {
                    label: dades[0].name,
                    data: dades[0].data,
                    borderColor: 'rgb(255, 41, 29)',
                    backgroundColor: 'rgb(255, 41, 29)',
                    pointStyle: 'circle',
                    borderWidth: 2
                },
                {
                    label: dades[1].name,
                    data: dades[1].data,
                    borderColor: 'rgb(255, 175, 0)',
                    backgroundColor: 'rgb(255, 175, 0)',
                    pointStyle: 'crossRot',
                    borderWidth: 2
                }
            ],
            options: {
                responsive: true,
                maintainAspectRatio: alcadaDefinida ? false : true,
                aspectRatio: 2 / 3,
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            usePointStyle: true
                        }
                    },
                    title: {
                        display: false,
                        text: 'Dies càlids i nits tropicals'
                    }
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'Anys'
                        },
                        ticks: {
                            callback: function (value) {
                                const label = this.getLabelForValue(value);
                                return label % 5 === 0 ? label : '';
                            }
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Núm. dies/nits'
                        },
                        min: minY,
                        max: maxY,
                        ticks: {
                            stepSize: 20
                        }
                    }
                }
            }
        };
    }

    // Dades històriques

    if ( type === "historicDies" ) {
        let dataSetsDies = [];
        const styles = [
            {
                rgb: 'rgb(255, 41, 39)',
                point: "circle"
            },
            {
                rgb: 'rgb(255, 175, 0)',
                point: "rectRot"
            },
            {
                rgb: 'rgb(54, 41, 147)',
                point: "rect"
            },
            {
                rgb: 'rgb(0, 200, 200)',
                point: "triangle"
            },
        ];

        dades.map((node, k) => {
            dataSetsDies.push({
                label: node.name,
                data: node.data,
                borderColor: styles[k].rgb,
                backgroundColor: styles[k].rgb,
                pointStyle: styles[k].point,
                borderWidth: 1
            })
        })

        return {
            labels: labelsFullDadesHistoriques,
            dataSets: dataSetsDies,
            options: {
                responsive: true,
                maintainAspectRatio: !alcadaDefinida,
                aspectRatio: 2 / 3,
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            usePointStyle: true
                        }
                    },
                    title: {
                        display: false,
                        text: 'Dies càlids, nits tropicals, dies de glaçada i dies de molta pluja'
                    }
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'Anys'
                        },
                        ticks: {
                            callback: function (value) {
                                if ( value%5 === 0) {
                                    return labelsFullDadesHistoriques[value];
                                }
                            }
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Núm. dies/nits'
                        },
                        ticks: {
                            stepSize: 20
                        }
                    }
                }
            }
        }
    }

    if ( type === "historicRatxes" ) {
        let dataSetsRatxes = [];
        const styles = [
            {
                rgb: 'rgb(200, 132, 1)',
                point: "circle"
            },
            {
                rgb: 'rgb(110, 93, 219)',
                point: "rectRot"
            },
            {
                rgb: 'rgb(51, 51, 51)',
                point: "rect"
            },
            {
                rgb: 'rgb(0, 253, 253)',
                point: "triangle"
            },
        ];

        dades.map((node, k) => {
            dataSetsRatxes.push({
                label: node.name,
                data: node.data,
                borderColor: styles[k].rgb,
                backgroundColor: styles[k].rgb,
                pointStyle: styles[k].point,
                borderWidth: 1
            })
        })

        return {
            labels: labelsFullDadesHistoriques,
            dataSets: dataSetsRatxes,
            options: {
                responsive: true,
                maintainAspectRatio: !alcadaDefinida,
                aspectRatio: 2 / 3,
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            usePointStyle: true
                        }
                    },
                    title: {
                        display: false,
                        text: 'Ratxa càlida, ratxa freda, ratxa seca i ratxa plujosa'
                    }
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'Anys'
                        },
                        ticks: {
                            callback: function (value) {
                                if ( value%5 === 0) {
                                    return labelsFullDadesHistoriques[value];
                                }
                            }
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Núm. dies/nits'
                        },
                        ticks: {
                            stepSize: 25
                        }
                    }
                }
            }
        }
    }

    if ( type === "historicTemperaturaMitjana" ) {
        return {
            labels: labelsFullDadesHistoriques,
            dataSets: [
                getBackgroundGradient(dades, 192, 17, 16, 2, "circle")
            ],
            options: {
                responsive: true,
                maintainAspectRatio: !alcadaDefinida,
                aspectRatio: 2 / 3,
                plugins: {
                    legend: {
                        display: false,
                    },
                    title: {
                        display: false,
                        text: 'Temperatura mitjana'
                    }
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'Anys'
                        },
                        ticks: {
                            callback: function (value) {
                                if ( value%5 === 0) {
                                    return labelsFullDadesHistoriques[value];
                                }
                            }
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Graus ºC'
                        },
                        ticks: {
                            stepSize: 1
                        }
                    }
                }
            }
        }
    }

    if ( type === "historicPrecipitacioAcumulada" ) {
        return {
            labels: labelsFullDadesHistoriques,
            dataSets: [
                {
                    data: dades.map((item) => {
                        return { x: item[0], y: item[1] };
                    }),
                    borderColor: 'rgb(0, 124, 123)',
                    backgroundColor: 'rgb(0, 124, 123)',
                    pointStyle: 'circle',
                    borderWidth: 2,
                    parsing: {
                        xAxisKey: 'x',
                        yAxisKey: 'y'
                    }
                }
            ],
            options: {
                responsive: true,
                maintainAspectRatio: !alcadaDefinida,
                aspectRatio: 2 / 3,
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: false,
                        text: 'Precipitacio acumulada'
                    }
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'Anys'
                        },
                        ticks: {
                            callback: function (value) {
                                if ( value%5 === 0) {
                                    return labelsFullDadesHistoriques[value];
                                }
                            }
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Pluja en mil·límetres (mm)'
                        },
                        ticks: {
                            stepSize: 250
                        }
                    }
                }
            }
        }
    }
};

export { getConfigGrafica };
